EMMY.contacts = {
  init: function() {
    // Show / hide contact details on the contacts pages
    if (document.getElementById('contactQuickLinks')) {
      EMMY.contacts.runContactSwap();
    }
    if (window.location.hash) {
      var hashVal = window.location.hash.substr(1).replace('contactId','');
      var activeElement = 'key' + hashVal;
      EMMY.contacts.actualShowHide(activeElement);
    }

    $(document).on('click', '.new-modal-trigger[data-target="#delete-contact-modal"]', function(e){
      target = $(this).data('target');
      var actionForm = $('#delete-contact-form-data').attr('action').split('/');
      actionForm[4] = $(this).data('contactid');
      var newAction = actionForm.join('/');
      $('#delete-contact-form-data').attr('action', newAction);
    });

  },

  runContactSwap: function() {
    var contactClicks = document.getElementsByClassName('contact-meta');
    Array.from(contactClicks).forEach(function(link) {
      link.addEventListener('click', function () {
        var activeElement = this.parentElement.classList[1];
        EMMY.contacts.actualShowHide(activeElement);
      });
    });
  },
  actualShowHide: function(element) {
    var contactVal = document.getElementById(element);
    if ($('.contacts').hasClass('pt-site')) {
      EMMY.contacts.hide(document.querySelectorAll('.contact-details'));
      EMMY.contacts.classActiveSwap(document.querySelectorAll('.contact-container'));
      document.querySelector('.contact-container.' + element).className += ' active';
      contactVal.style.display = 'block';
    }
  },

  hide: function(elements) {
    elements = elements.length ? elements : [elements];
    for (var index = 0; index < elements.length; index++) {
      elements[index].style.display = 'none';
    }
  },

  classActiveSwap: function(elements) {
    elements = elements.length ? elements : [elements];
    for (var index = 0; index < elements.length; index++) {
      var classListing = elements[index].className;
      if (classListing.indexOf('active') != -1) {
        elements[index].className = classListing.replace('active','');
      }
    }
  },
  paymentAjaxAddContact: function() {
    var contactData = $('#contactForm').serialize();
    var firstName = $('#first_name').val();
    var lastName = $('#last_name').val();
    var email = $('#contactForm #email').val();
    $.ajax({
      url: '/contacts',
      type: 'post',
      data: contactData,
      success: function (data) {
        var billingContactSelect = $("#billing_contact");
        var contactId = data.contact_id;
        billingContactSelect.select2('destroy');
        billingContactSelect.append($('<option>', {
          value: contactId,
          text: firstName + ' ' + lastName,
        }));
        billingContactSelect.find('option:nth-last-child(2)').appendTo(billingContactSelect);
        if($('.laa-site').val() != undefined) {
          billingContactSelect.find('option[value="-1"]').remove();
        }
        billingContactSelect.select2().val(contactId).trigger('change');
        EMMY.modals.bodyClass.classList.toggle('modal-open');
        $('#invoiceForm #email_order').val(email);
        $('#invoiceForm #email_order').parent().removeClass('required');
        $('#contactForm')[0].reset();
      }
    });
  },
  triggerModal: function() {
    EMMY.modals.bodyClass.classList.toggle('modal-open');
  },
  invoiceUpdates: function(billingSelect) {
    if ($(billingSelect).val() == '-1') {
      EMMY.contacts.triggerModal();
      $(billingSelect).val([]);
    } else {
      var selected = $(billingSelect).find('option:selected');
      var emailAddress = selected.data('email');
      $('#email_order').val(emailAddress);
    }
  }
}

